<script lang="ts">
	import Cell from './Cell.svelte';
	import type { GameField } from "./game";

	export let cells: GameField;

	// noinspection JSUnusedAssignment
	let style = `max-width: calc(40px * ${cells[0].length}); ` +
		`grid-template-columns: repeat(${cells[0].length}, 40px)`;
</script>

<div {style}>
	{#each cells as rows}
		{#each rows as cell}
			<Cell {cell} on:cell_clicked/>
		{/each}
	{/each}
</div>

<style>
	div {
		margin: auto;
		display: grid;
		/*grid-template-columns: repeat(15, 40px);*/
		grid-auto-rows: 40px;
		border: 1px solid #ccc;
		/*max-width: calc(40px * 15);*/
		grid-gap: 0;
		user-select: none;
		-webkit-touch-callout: none;
	}
</style>
